import React from "react"
import Title from './title'
import logo from '../images/Cubeia_logo-white.png'
import { FaMapMarkerAlt } from 'react-icons/fa';
import { FaEnvelope } from 'react-icons/fa';
import {ContactAddressStyled} from './contactAddressStyled'




const ContactAddress = () => {
    return <ContactAddressStyled>
            <div className="addressSection">
                <Title position="Contact" className="titleContactWrap" />
                <img src={logo} className="brandLogo" alt="Cubeia logo"/>
                <div className="contactWrap">
                    <div className="detailWrap">
                        <div className="emailWrap">
                            <FaEnvelope />
                            <p className="email">contact@cubeia.com</p>
                        </div>
                        <div className="addressWrap">
                            <FaMapMarkerAlt />
                            <p className="address">
                            Stadsgården 6, 116 45 Stockholm Sweden
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2035.7993563599905!2d18.07063017781768!3d59.31960731179829!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x465f77fb57761567%3A0x84a88171b17264a1!2sStadsg%C3%A5rden%206%2C%20116%2045%20Stockholm!5e0!3m2!1sen!2sse!4v1704047999529!5m2!1sen!2sse"
                frameBorder="0" allowFullScreen="" title="cubeia map" className="map"></iframe>
            </ContactAddressStyled>
}
 export default ContactAddress
